<template>
  <div>
    <v-list-item>
      <router-link :to="menu.MenuLink" v-slot="{ navigate }">
        <a
          :href="`#${menu.MenuLink}`"
          @click="navigate"
          :style="menu.MenuStyle"
        >
          <i :class="menu.MenuIcon" :style="menu.MenuStyle"></i> &nbsp;
          <span class="menu-text"> {{ menu.MenuText }} </span>
        </a>
      </router-link></v-list-item
    >
  </div>
</template>

<script>
export default {
  props: {
    menu: {
      type: Object,
      required: true,
    },
    menuId: {
      required: true,
    },
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
</style>